import { render, staticRenderFns } from "./LeonidaPrenotazioneView.vue?vue&type=template&id=156203f3"
import script from "./LeonidaPrenotazioneView.vue?vue&type=script&lang=js"
export * from "./LeonidaPrenotazioneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports